<template>
  <material-card
    color="accent"
    :title="$t('limitations')"
    class="mb-6 pb-2 card-block"
  >
    <v-row class="ma-2">
      <v-col
        v-for="limiter in limiters"
        v-show="component[limiter.type]"
        :key="limiter.type"
        cols="3"
      >
        <v-card>
          <v-card-title class="text-h5">
            {{ $t('fields.'+limiter.type) }}
          </v-card-title>
          <v-list
            class="transparent"
            dense
          >
            <v-list-item
              v-for="item in limiter.fields"
              :key="item"
            >
              <v-list-item-title>{{ $t('fields.'+item) }}</v-list-item-title>

              <v-list-item-subtitle v-if="limiter.format === 'minToTimeFormat' && component[item] !== null" class="text-right">
                {{ item === 'current_counter_flight' ? component[item] : component[item]*60 | minToTimeFormat }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else class="text-right">
                {{ component[item] }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </material-card>
</template>

<script>

  export default {
    name: 'ComponentInformations',
    props: {
      component: {
        type: Object,
        default: () => ({}),
      },
    },
    data: () => ({
      panel: [0, 1, 2, 3],
      limiters: [
        {
          type: 'date_limiter',
          fields: [
            'cycle_date',
            'limit_date',
            'lifetime_date',
          ],
        },
        {
          type: 'takeoff_limiter',
          fields: [
            'start_counter_takeoff',
            'cycle_counter_takeoff',
            'limit_counter_takeoff',
            'current_counter_takeoff',
            'lifetime_counter_takeoff',
          ],
        },
        {
          type: 'flight_limiter',
          fields: [
            'start_counter_flight',
            'cycle_counter_flight',
            'limit_counter_flight',
            'current_counter_flight',
            'lifetime_counter_flight',
          ],
          format: 'minToTimeFormat',
        },
        {
          type: 'engine_limiter',
          fields: [
            'start_counter_engine',
            'cycle_counter_engine',
            'limit_counter_engine',
            'current_counter_engine',
            'lifetime_counter_engine',
          ],
        },
      ],
    }),
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
